@if (infoSteps().length) {
  <div class="mb-5 mb-lg-6">
    <mwe-basic-card data-test="mwe-new-client-status-steps">
      <mwe-next-steps [infoSteps]="infoSteps()" stepsTitle="newClient.status.steps.title" />
    </mwe-basic-card>
  </div>
}

<div class="mb-4">
  <mwe-address [address]="address()" [isAddressDetailsBodyVisible]="true" [isArrowDownHidden]="false" />
</div>
@if (stromOrGasProducts()?.length) {
  <div class="mb-4" data-test="products-summary-strom-gas-container">
    <mwe-headline
      [headlineLevelIncrement]="0"
      [text]="registerStromGasTitle()"
      cssClass="mt-6"
      data-test="summary-register-strom-gas-title"
    />

    <!--  Removed for Change MWE-15157 -->
    <!--  <span-->
    <!--    [innerHTML]="registerStromGasText() | translate: { registrationAt: registrationAt() }"-->
    <!--    class="text&#45;&#45;big"-->
    <!--    data-test="products-summary-strom-gas-register-text"-->
    <!--  ></span>-->
    @if (selectedTariffs()?.length > 0) {
      @if (isSummaryProductsFromWevTitleVisible()) {
        <mwe-headline
          [headlineLevelIncrement]="1"
          cssClass="h4 mt-6"
          text="summary.productsFromWEV"
          data-test="summary-products-from-wev"
        />
      }
      <div class="row mt-3 mb-0 gap-5 gap-md-6" data-test="products-summary-strom-gas-products">
        <mwe-tariff-selection-container
          [selectedTariffs]="selectedTariffs()"
          [isReadOnly]="true"
          [headlineReference]="headlineService.getHeadline(1)"
          [isKundeWerden]="isKundeWerden()"
        />
      </div>
    } @else {
      <div class="row mt-3 mb-0" data-test="products-summary-strom-gas-products">
        @for (product of stromOrGasProducts(); track product) {
          <div class="col-12 col-lg-6 mb-4">
            <mwe-basic-card>
              <mwe-wizard-product-card
                [product]="product"
                [showTariffDetailsLink]="showTariffDetailsLink()"
                [showTariffDetails]="showStromGasTarifDetails() && showTariffDetails()"
                [isAvailable]="true"
                [tariffClasses]="product.tariffClasses"
                [tarifKey]="product.tarifKey"
                [productSelection]="productSelection()"
                [grundpreisLabelOverwrite]="grundpreisLabelOverwrite()"
                [attr.data-test]="'products-summary-card-' + product.category?.toLowerCase()"
              />
            </mwe-basic-card>
          </div>
        }
      </div>
    }
  </div>
}

@if (showBenefitsCard()) {
  <div class="mb-4">
    <mwe-basic-card [hasBackground]="true">
      <mwe-basic-card-title
        [cardTitle]="'summary.yourBenefits'"
        [headingNodeType]="headlineService.getHeadline(0)"
        [iconClass]="'fa-gift'"
      />
      @if (voucherInfo()) {
        <div>
          <mwe-headline
            cssClass="font-size-16 lh-base"
            data-test="products-summary-additionalDetails-voucher-headline"
            [headlineLevelIncrement]="1"
            text="summary.voucherInfo.title"
            [textParams]="{ voucherCode: voucherInfo().aktionscode }"
          />
          <p class="text--big mb-0" data-test="products-summary-additionalDetails-voucher">
            @if (voucherStrom()?.length > 0) {
              <span
                class="d-inline-block pb-2"
                [innerHTML]="'<strong>' + ('products.category.strom' | translate) + ':</strong> ' + voucherStrom() + '<br/>'"
              ></span>
            }
            @if (voucherGas()?.length > 0) {
              <span
                class="d-inline-block pb-2"
                [innerHTML]="'<strong>' + ('products.category.gas' | translate) + ':</strong> ' + voucherGas() + '<br/>'"
              ></span>
            }
          </p>
        </div>
      }
    </mwe-basic-card>
  </div>
}

@if (showAdditionalInfoBox() && mgmCode()) {
  <mwe-infobox
    titleKey="newClient.mgm.summaryTitle"
    [messageKey]="isSummary() ? 'newClient.mgm.summaryTextLastActivity' : 'newClient.mgm.summaryText'"
  />
}

@if (fernwaermeProducts()?.length) {
  <div class="mb-4">
    <mwe-headline [headlineLevelIncrement]="0" [text]="registerFernwaermeTitle()" cssClass="h3 mt-6" />
    <span
      [innerHTML]="registerFernwaermeText() | translate: { address: formattedAddress() }"
      class="text--big"
      data-test="products-summary-register-fernwaerme-text"
    ></span>
    <div class="row mt-3 g-3">
      <mwe-product-icon [category]="Sparte.Fernwaerme" size="md" [showText]="false" class="col-auto mt-4" />
      <div class="col">
        <mwe-headline [headlineLevelIncrement]="1" cssClass="mb-0" text="newClient.tariffSelection.waerme.waerme" />
        <p class="text--legal">{{ Sparte.Fernwaerme | correlatedCompanyReference }}</p>
      </div>
    </div>
    @if (registerFernwaermeSubTitle()) {
      <p [translate]="registerFernwaermeSubTitle()" class="text--big"></p>
    }
    <div class="row mt-3">
      @for (product of fernwaermeProducts(); track product) {
        <div class="col-12 col-lg-6 mb-4">
          <div class="mb-3">
            <mwe-tariff-card-waerme
              [headlineReference]="headlineService.getHeadline(2)"
              [product]="product"
              [hideNoTariffsMessage]="true"
            />
          </div>
          <mwe-infobox messageKey="newClient.tariffSelection.waerme.noTariffs" data-test="new-client-tariff-selection-fernwaerme" />
        </div>
      }
    </div>
  </div>
}

<div class="mb-4">
  <mwe-headline [headlineLevelIncrement]="0" cssClass="h3 mt-6 mb-4" text="summary.yourContractDetails" />
  <mwe-basic-card [hasBackground]="true">
    <mwe-basic-card-title
      [cardTitle]="'summary.contractDataCardTitle'"
      [headingNodeType]="headlineService.getHeadline(1)"
      [iconClass]="'fa-file-user'"
    />
    <mwe-headline
      cssClass="font-size-16 lh-base"
      [headlineLevelIncrement]="2"
      [text]="customerDataType() !== 'Businesskunde' ? 'summary.personalData' : 'summary.businessData'"
    />
    <ul class="list-separated spacing-4" data-test="products-summary-customerData">
      <li data-test="products-summary-customerData-name">
        <p [classList]="!fernwaermeProducts()?.length && 'mb-0'" class="text--big">
          @if (customerDataType() === 'Businesskunde') {
            @if (businessData()?.companyName) {
              <span> <span translate="newClient.summary.companyName"></span>: {{ businessData()?.companyName }} </span>
            }
            <span data-test="products-summary-customer-name">
              {{ salutation() ? salutation() + ' ' : '' }}{{ title() ? title() + ' ' : '' }}{{ firstname() }} {{ lastname() }}
            </span>
            @if (businessData()?.uidNumber) {
              <span> <br /><span translate="newClient.summary.uidNumber"></span>: {{ businessData().uidNumber }} </span>
            }
            @if (businessData()?.corporateRegisterNumber) {
              <span>
                <br /><span translate="newClient.summary.corporateRegisterNumber"></span>: {{ businessData().corporateRegisterNumber }}
              </span>
            }
          }
          @if (!customerDataType() || customerDataType() === 'Privatkunde') {
            <span data-test="products-summary-customer-name">
              {{ fullNameWithTitle() }}
            </span>
            <span data-test="products-summary-customer-birthdate"> <br />{{ birthDate() }} </span>
          }
          @if (telefonNumber()) {
            <br />
            <span data-test="products-summary-customer-phonenumber">
              {{ countryCode() | formatPhoneNumber: telefonNumber() }}
            </span>
          }
          <br />
          <span data-test="products-summary-customer-email">
            {{ email() }}
          </span>
          <ng-content select="[slot='products-summary-customerData-name-additionalContent']" />
        </p>
        @if (fernwaermeProducts()?.length) {
          <mwe-infobox messageKey="newClient.summary.districtHeatingInfo" />
        }
      </li>
      @if (idCard() && idCard().art === 'Ausweis') {
        <li data-test="products-summary-customerData-idCard">
          <p class="text--big mb-0">
            <strong><span translate="summary.idData"></span></strong>
            <br />
            {{ idCard().type }}, {{ idCard().number }}, {{ idCard().issuer }}
          </p>
        </li>
      }
    </ul>
    @if (selectedTariffs()?.length && tariffContractInfos()?.length) {
      @for (contractInfo of tariffContractInfos(); track contractInfo.title) {
        <hr />
        <mwe-product-summary-contract-info [showDeliveryInfos]="true" [contractInfos]="contractInfo" />
      }
    }
    <hr />
    <mwe-products-summary-invoice-old
      [additionalBulletPoints]="additionalBulletPointsStromGas()"
      [areBankAccountInfoTextsVisible]="areBankAccountInfoTextsVisible()"
      [contactDataEmailAddress]="contactDataEmailAddress()"
      [eRechnungInfo]="eRechnungInfo()"
      [formattedAddress]="formattedAddressC()"
      [infoTextCardLabel]="infoTextCardLabel()"
      [isPaymentInfoVisible]="isPaymentInfoVisible()"
      [paymentIcon]="paymentIcon()"
      [paymentText]="paymentText()"
      [personalBillingTitle]=""
      [productCategories]="productCategories()"
      billingAddressTitleText="summary.eBillingAddress"
      contactDataEmailAddressLabelClass="text-blue d-inline-block pb-2"
      eBillingLabelClass="text-blue d-inline-block pb-2"
      paymentDataLabelClass="text-blue d-inline-block pb-2"
      shippingEmailTitleText="summary.invoiceAddress.shipping.emailPrefix"
      summaryBillingTitleText="summary.invoiceShipping"
      [headlineNodeType]="headlineService.getHeadline(2)"
    />
  </mwe-basic-card>
</div>
<ng-content select=".after-invoice" />

@if (showAdditionalInfoBox()) {
  <mwe-basic-card [hasBackground]="true" class="d-block mb-4">
    <mwe-basic-card-title
      [cardTitle]="'summary.additionalInformation'"
      [headingNodeType]="headlineService.getHeadline(1)"
      [iconClass]="'fa-lightbulb-on'"
    />
    <div class="row w-100">
      <div class="col-12">
        <ul class="list-separated spacing-4" data-test="products-summary-additionalDetails">
          @if (showMeterReading()) {
            <li data-test="products-summary-additionalDetails-showMeterReading">
              <mwe-headline [headlineLevelIncrement]="2" cssClass="font-size-16 lh-base" text="summary.meterReading.title" />
              <p>{{ 'summary.meterReading.text' | translate }}</p>
              <mwe-infobox messageKey="summary.meterReading.infoBox.text" />
            </li>
          }
          @if (showFormCardInfo()) {
            <li data-test="products-summary-additionalDetails-showFormCardInfo">
              <mwe-headline [headlineLevelIncrement]="2" cssClass="font-size-16 lh-base" text="summary.formCardInfo.title" />
              <p class="mb-0">
                <span>{{ 'summary.formCardInfo.description' | translate }}</span>
              </p>
            </li>
          }
        </ul>
      </div>
    </div>
  </mwe-basic-card>
}

@if (registerStromGasInfoMessage()) {
  <div class="w-100 mt-4 mb-4">
    <mwe-infobox [messageKey]="registerStromGasInfoMessage()" type="info" />
  </div>
}
